import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';
import MainSectionCarriers from 'tailwind-components/CarrierAppointments/MainSectionCarriers';
import { ALL_CARRIERS_TAB_ID } from './constants';
import {
  getAppointedCarrierNameSet,
  getGroupedCarriersByParent
} from 'helpers/carriers/carriers';
import { isAgentAppointedWithCarrier } from 'helpers/appointments/appointments';

export default function CommissionsCarrierSection({
  currentTab,
  activeCarrierName,
  onCarrierClick,
  localLoader,
  appointedCarriers
}) {
  const user = useSelector(state => state.user.zohoData);
  const { carriersArray } = useSelector(state => state.appointments);

  const filteredCarriersArray = useMemo(
    () =>
      carriersArray.filter(carrier => {
        const isAppointed = isAgentAppointedWithCarrier(carrier.name, user);
        return !carrier.appointmentsDisabled || isAppointed;
      }),
    [carriersArray, user]
  );

  const appointedCarrierNames = useMemo(
    () => getAppointedCarrierNameSet(appointedCarriers),
    [appointedCarriers]
  );

  const groupedCarriers = useMemo(() => {
    if (currentTab === ALL_CARRIERS_TAB_ID) {
      return getGroupedCarriersByParent(
        filteredCarriersArray,
        undefined,
        null
      );
    }

    return getGroupedCarriersByParent(
      filteredCarriersArray,
      currentTab,
      appointedCarrierNames
    );
  }, [filteredCarriersArray, currentTab, appointedCarrierNames]);

  return (
    <div className='flex min-h-0 min-w-0 w-full flex-1 flex-col'>
      {localLoader ? (
        <div className='rounded-xl bg-white p-4'>
          <div className='equal-rows simple-carrier-grid grid gap-1.5'>
            {Array.from({ length: 8 }).map((_, i) => (
              <div
                key={i}
                className='h-[90px] min-w-0 animate-pulse rounded-lg bg-gray-100'
              />
            ))}
          </div>
        </div>
      ) : (
        <MainSectionCarriers
          groupedCarriers={groupedCarriers}
          onCarrierClick={onCarrierClick}
          activeCarrierName={activeCarrierName}
          useSimpleCarrierCards
        />
      )}
    </div>
  );
}

CommissionsCarrierSection.propTypes = {
  currentTab: propTypes.string.isRequired,
  activeCarrierName: propTypes.string,
  onCarrierClick: propTypes.func.isRequired,
  localLoader: propTypes.bool,
  appointedCarriers: propTypes.object
};
